<template>
  <div class="footer__wrapper">
    <div class="mobile-view">
      <div class="content">
        <div class="footer__head">
          <div v-if="activeCity" class="footer__contacts">
            <NuxtLink class="footer__phone" :href="'tel:' + activeCity?.contacts[0]?.phone">
              {{ activeCity?.contacts[0]?.phone }}
            </NuxtLink>

            <NuxtLink class="footer__mail" :href="'mailto:' + activeCity?.contacts[0]?.email">
              {{ activeCity?.contacts[0]?.email }}
            </NuxtLink>

            <div class="footer__address">
              {{ activeCity?.contacts[0]?.address[0][locale] }}
            </div>

            <div class="footer__year">
              {{ activeCity?.contacts[0]?.copyright }}
            </div>
          </div>

          <div class="footer__logos">
            <NuxtLink class="footer__logo" to="/">
              <NuxtImg format="webp" width="118px" height="37px" densities="x1" :src="logos.logoUrl">
              </NuxtImg>
            </NuxtLink>
            <NuxtLink class="footer__logo" to="https://setlgroup.ru/">
              <NuxtImg :width="104" :height="45" :src="logos.brandUrl"/>
            </NuxtLink>
          </div>
        </div>

        <div class="footer__main">
          <div class="footer__home">
            <div class="footer__title">{{ $t("footer.home") }}</div>
            <ul class="footer__list">
              <li v-for="service in services" :key="service.id" class="footer__item">
                <NuxtLink :to="`/services/${service.slug[locale]}?id=${service.id}`">
                  {{ service.title[0][locale] }}
                </NuxtLink>
              </li>
            </ul>
          </div>
          <div class="footer__about">
            <NuxtLink class="footer__title" :to="'/about'">{{ $t("footer.about") }}</NuxtLink>
            <ul class="footer__list">
              <li class="footer__item">
                <NuxtLink to="/about">{{
                    $t("footer.aboutCompany")
                  }}
                </NuxtLink>
              </li>
              <li class="footer__item">
                <NuxtLink to="/documents">{{
                    $t("footer.documents")
                  }}
                </NuxtLink>
              </li>
              <li class="footer__item">
                <NuxtLink to="/news">{{ $t("footer.news") }}</NuxtLink>
              </li>
              <li class="footer__item">
                <NuxtLink to="/career">{{
                    $t("footer.career")
                  }}
                </NuxtLink>
              </li>
              <li class="footer__item">
                <NuxtLink to="/contacts">{{
                    $t("footer.contacts")
                  }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer__policy">
          <ul class="footer__list policy__list">
            <li v-for="document in documents" :key="document.id" class="footer__item policy__item">
              <NuxtLink
                :to="useRuntimeConfig().public.storage_host + document.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ document.title[0][locale] }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tablet-view">
      <div class="content">
        <div v-if="activeCity" class="footer__head">
          <div class="footer__logos">
            <NuxtLink to="/">
              <NuxtImg format="webp" densities="x1" width="118px" height="37px" :src="logos.logoUrl">
              </NuxtImg>
            </NuxtLink>
            <NuxtLink target="_blank" to="https://setlgroup.ru/">
              <NuxtImg :width="95" :height="41" :src="logos.brandUrl" class="footer__logo"/>
            </NuxtLink>
          </div>
          <NuxtLink class="footer__phone" :href="'tel:' + activeCity?.contacts[0]?.phone">
            {{ activeCity?.contacts[0]?.phone }}
          </NuxtLink>

          <NuxtLink class="footer__mail" :href="'mailto:' + activeCity?.contacts[0]?.email">
            {{ activeCity?.contacts[0]?.email }}
          </NuxtLink>
          <div class="footer__address">
            {{ activeCity?.contacts[0]?.address[0][locale] }}
          </div>
        </div>

        <div class="footer__main">
          <div class="footer__description">
            <div class="footer__home">
              <NuxtLink class="footer__title" to='/'>{{ $t("footer.home") }}</NuxtLink>
              <ul class="footer__list">
                <li class="footer__item">
                  <NuxtLink :to="'/#experts'">{{
                      $t("footer.advantages")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink :to="'/#services'">{{
                      $t("footer.services")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink :to="'/#projects'">{{
                      $t("footer.clients")
                    }}
                  </NuxtLink>
                </li>
              </ul>
            </div>

            <div class="footer__products">
              <div class="footer__title">{{ $t("footer.services") }}</div>
              <ul class="footer__list">
                <li v-for="service in services" :key="service.id" class="footer__item">
                  <NuxtLink :to="`/services/${service.slug[locale]}?id=${service.id}`">
                    {{ service.title[0][locale] }}
                  </NuxtLink>
                </li>
              </ul>
            </div>

            <div class="footer__about">
              <div class="footer__title">{{ $t("footer.about") }}</div>
              <ul class="footer__list">
                <li class="footer__item">
                  <NuxtLink to="/about">{{
                      $t("footer.aboutCompany")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/documents">{{
                      $t("footer.documents")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/news">{{
                      $t("footer.news")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/career">{{
                      $t("footer.career")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/contacts">{{
                      $t("footer.contacts")
                    }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
          </div>

          <div class="footer__policy">
            <div class="footer__year">
              {{ activeCity?.contacts[0]?.copyright }}
            </div>
            <ul class="footer__list policy__list">
              <li v-for="document in documents" :key="document.id" class="footer__item policy__item">
                <NuxtLink
                  :to="useRuntimeConfig().public.storage_host + document.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ document.title[0][locale] }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="desktop-view">
      <div class="content">
        <div class="footer__head">
          <div class="footer__logos">
            <NuxtLink to="/">
              <NuxtImg class="footer__address-img" :src="logos.logoUrl" alt="address-img">
              </NuxtImg>
            </NuxtLink>
            <NuxtLink target="_blank" to="https://setlgroup.ru/">
              <NuxtImg :width="118" :height="51" :src="logos.brandUrl" class="footer__logo">
              </NuxtImg>
            </NuxtLink>
          </div>

          <div class="footer__description">
            <div class="footer__home">
              <div class="footer__title">
                <NuxtLink :to="'/'">{{ $t("footer.home") }}</NuxtLink>
              </div>
              <ul class="footer__list">
                <li class="footer__item">
                  <NuxtLink to="/#experts">{{
                      $t("footer.advantages")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/#services">{{
                      $t("footer.services")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/#projects">{{
                      $t("footer.clients")
                    }}
                  </NuxtLink>
                </li>
              </ul>
            </div>

            <div class="footer__products">
              <div class="footer__title">{{ $t("footer.services") }}</div>
              <ul class="footer__list">
                <li v-for="service in services" :key="service.id" class="footer__item">
                  <NuxtLink :to="`/services/${service.slug[locale]}?id=${service.id}`">
                    {{ service.title[0][locale] }}
                  </NuxtLink>
                </li>
              </ul>
            </div>

            <div class="footer__about">
              <div class="footer__title">{{ $t("footer.about") }}</div>
              <ul class="footer__list">
                <li class="footer__item">
                  <NuxtLink to="/about">{{
                      $t("footer.aboutCompany")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/documents">{{
                      $t("footer.documents")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/news">{{
                      $t("footer.news")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/career">{{
                      $t("footer.career")
                    }}
                  </NuxtLink>
                </li>
                <li class="footer__item">
                  <NuxtLink to="/contacts">{{
                      $t("footer.contacts")
                    }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="activeCity" class="footer__contacts">
            <NuxtLink class="footer__phone" :href="'tel:' + activeCity?.contacts[0]?.phone">
              {{ activeCity?.contacts[0]?.phone }}
            </NuxtLink>

            <NuxtLink class="footer__mail" :href="'mailto:' + activeCity?.contacts[0]?.email">
              {{ activeCity?.contacts[0]?.email }}
            </NuxtLink>

            <div class="footer__address">
              {{ activeCity?.contacts[0]?.address[0][locale] }}
            </div>

            <div class="footer__year">
              {{ activeCity?.contacts[0]?.copyright }}
            </div>
          </div>

          <div class="footer__buttons">
            <div v-if="activeCity" class="footer__buttons-city">
              {{ $t("footer.city") }}
              {{ activeCity.name[0][locale] }}
            </div>
            <div class="footer__policy">
              <ul class="footer__list policy__list">
                <li v-for="document in documents" :key="document.id" class="footer__item policy__item">
                  <NuxtLink
                    :to="useRuntimeConfig().public.storage_host + document.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ document.title[0][locale] }}
                  </NuxtLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCitiesStore } from '~/stores/cities/cities.ts'
import { useLogosStore } from '~/stores/logos/logos.ts'
import { useServicesStore } from "~/stores/services/services.ts";
import { useDocumentsStore } from "~/stores/documents/documents";
import { useLocalesStore } from "~/stores/locales/locales";

const { locale } = storeToRefs(useLocalesStore());
const { services } = storeToRefs(useServicesStore());
const { logos } = storeToRefs(useLogosStore());
const { activeCity } = storeToRefs(useCitiesStore());
const { documents } = storeToRefs(useDocumentsStore());
</script>

<style lang="scss" scoped>
.mobile-view,
.tablet-view {
  display: none;
}

.footer__head {
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.footer__logos {
  display: flex;
  flex-direction: column;
  gap: 16.5px;
}

.footer__address-img {
  cursor: pointer;
  width: 152px;
}

.footer__description {
  display: flex;
  gap: 30px;

  @media (min-width: $screen-xl) {
    gap: 50px;
  }
}

.footer__title {
  margin-bottom: 24px;
  color: #282828;
}

.footer__title a {
  color: #282828;
}

.footer__item a {
  color: #282828;
}

.policy__item {
  &:not(:last-child) {
    margin-bottom: 0;

    @media(max-width: $screen-m) {
      margin-bottom: 12px;
    }
  }
}

.footer__contacts {
  max-width: 190px;

  & div {
    &:not(:last-child) {
      margin-bottom: 11px;
    }
  }
}

.footer__phone {
  display: block;
  margin-bottom: 11px;
}

.footer__mail {
  cursor: pointer;
  display: block;
  margin-bottom: 11px;
}

.policy__list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

@media (min-width: 1280px) {
  .policy__list {
    flex-direction: column;
    gap: 20px;
  }
}

@media(min-width: 768px) and (max-width: 1279px) {
  .tablet-view {
    display: block;
  }

  .mobile-view,
  .desktop-view {
    display: none;
  }

  .content {
    display: flex;
    gap: 45px;
  }

  .footer__head {
    max-width: 167px;
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .footer__logos {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 30px;
  }

  .footer__phone {
    margin-bottom: 6px;
  }

  .footer__mail {
    cursor: pointer;
    display: block;
  }

  .footer__address {
    margin: 12px 0 24px;
  }

  .footer__main {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .footer__description {
    display: flex;
    justify-content: space-between;
  }

  .footer__title {
    display: block;
    margin-bottom: 24px;
  }

  .footer__policy {
    margin-top: 9px;
  }

  .policy__item {
    text-decoration: underline;
    -webkit-text-decoration-skip-ink: none;
    text-decoration-skip-ink: none;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}

@media(max-width: 768px) {
  .mobile-view {
    display: block;
  }

  .tablet-view,
  .desktop-view {
    display: none;
  }

  .footer__description {
    gap: 0;
  }

  .footer__head {
    margin-bottom: 24px;
  }

  .footer__phone {
    margin-bottom: 6px;
  }

  .footer__mail {
    cursor: pointer;
    display: block;
    margin-bottom: 16px;
  }

  .footer__address {
    margin-bottom: 17px;
  }

  .footer__button {
    width: 100%;
  }

  .footer__logos {
    display: flex;
    flex-direction: column;
  }

  .footer__logo {
    &:not(:last-child) {
      margin-bottom: 16.5px;
    }
  }

  .footer__main {
    display: flex;
    justify-content: space-between;
    padding-top: 24px;
    border-top: 1px solid rgba(40, 40, 40, 0.16);

    & div:first-child {
      @media (max-width: 768px) {
        margin-bottom: 16px;
      }
    }

    & div:last-child {
      @media (max-width: 460px) {
        margin-right: 0;
      }
    }
  }

  .footer__policy {
    padding-top: 24px;
    border-top: 1px solid rgba(40, 40, 40, 0.16);
  }

  .footer__list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: column;
  }

  .footer__item {
    color: #7a7a7a;
  }

  .policy__list {
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-top: 0;
  }

  .policy__item {
    font-size: 14px;
    text-decoration: underline;
    -webkit-text-decoration-skip-ink: none;
    text-decoration-skip-ink: none;
  }

  .footer__home {
    max-width: 259px;
    margin-right: 16px;
  }

  .footer__about {
    max-width: 259px;
  }

  .footer__services {
    max-width: 140px;
    min-width: fit-content;
    margin-bottom: 24px;
  }

  .footer__item a {
    color: #7a7a7a;
  }

  .footer__title {
    display: block;
    color: #7a7a7a;
    margin-bottom: 16px;
  }

  .footer__service {
    margin-top: 8px;
    margin-bottom: 16px;
  }
}
</style>
